import { SHOW_PERMISSIONS_MODAL } from './types';

export function showPermissionsModal(value: boolean) {
  return {
    type: SHOW_PERMISSIONS_MODAL,
    payload: value,
  };
}
